module.exports = __webpack_public_path__ + "img/voice-thumb2.0339134.jpg";